import { useEffect, useState } from "react";
import { Toast, ToastContainer, Button } from "react-bootstrap";

const typeColors = {
  success: "bg-success text-white",
  alert: "bg-warning text-dark",
  error: "bg-danger text-white",
};

const Toaster = ({ notification, onClose }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (notification) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
        onClose?.();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [notification, onClose]);

  if (!notification) return null;

  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
      <Toast
        show={show}
        onClose={() => {
          setShow(false);
          onClose?.();
        }}
        delay={5000}
        autohide
      >
        <Toast.Body className={`d-flex justify-content-between align-items-center ${typeColors[notification.type] || typeColors.success}`}>
          <span>{notification.message}</span>
          <Button
            variant="link"
            onClick={() => {
              setShow(false);
              onClose?.();
            }}
            className="text-white p-0 ms-3"
            style={{ fontWeight: "bold", textDecoration: "none" }}
          >
            ✖
          </Button>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default Toaster;
